// Full-screen in-call video UI for the user side. Mounts once the lawyer
// accepts, joins the Agora channel via useAgora, and renders remote + local video.
import { useEffect, useState } from "react";
import { useAgora } from "./useAgora";
import VideoPlayer from "./VideoPlayer";
import "./call.css";

function fmt(total) {
  const m = String(Math.floor(total / 60)).padStart(2, "0");
  const s = String(total % 60).padStart(2, "0");
  return `${m}:${s}`;
}

export default function CallScreen({ call, onEnd }) {
  const { status, error, remoteUsers, localVideoTrack, micOn, camOn, toggleMic, toggleCam } =
    useAgora(call.creds);
  const [seconds, setSeconds] = useState(0);

  useEffect(() => {
    if (status !== "connected") return;
    const id = setInterval(() => setSeconds((s) => s + 1), 1000);
    return () => clearInterval(id);
  }, [status]);

  const remoteVideoTrack = remoteUsers[0]?.videoTrack;

  return (
    <div className="lp-call-screen">
      <div className="lp-remote">
        {remoteVideoTrack ? (
          <VideoPlayer track={remoteVideoTrack} className="lp-remote-video" />
        ) : (
          <div className="lp-remote-placeholder">
            <div className="lp-ph-avatar">
              {call.lawyer?.picture ? (
                <img src={call.lawyer.picture} alt={call.lawyer?.name} />
              ) : (
                <i className="bi bi-person-fill" />
              )}
            </div>
            <div className="lp-ph-text">
              {status === "connected"
                ? `Waiting for ${call.lawyer?.name || "the lawyer"}…`
                : status === "failed"
                ? error || "Could not start the call."
                : "Connecting…"}
            </div>
          </div>
        )}
      </div>

      <div className="lp-call-top">
        <span className="lp-timer">{fmt(seconds)}</span>
        <span className="lp-enc"><span className="lp-enc-dot" /> Encrypted</span>
      </div>

      <div className={camOn ? "lp-pip" : "lp-pip lp-pip-off"}>
        {localVideoTrack && camOn && <VideoPlayer track={localVideoTrack} />}
        <div className="lp-pip-off-label">Camera off</div>
      </div>

      <div className="lp-call-info">
        <div className="lp-call-name">{call.lawyer?.name || "Lawyer"}</div>
      </div>

      <div className="lp-call-controls">
        <button className={micOn ? "lp-call-btn" : "lp-call-btn lp-active"} onClick={toggleMic}>
          <i className={micOn ? "bi bi-mic-fill" : "bi bi-mic-mute-fill"} />
        </button>
        <button className={camOn ? "lp-call-btn" : "lp-call-btn lp-active"} onClick={toggleCam}>
          <i className={camOn ? "bi bi-camera-video-fill" : "bi bi-camera-video-off-fill"} />
        </button>
        <button className="lp-call-btn lp-call-end" onClick={onEnd}>
          <i className="bi bi-telephone-x-fill" />
        </button>
      </div>
    </div>
  );
}
